var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChargeShare = function SvgChargeShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M9.976 11.738a4.7 4.7 0 0 1-1.85.357q-1.176 0-2.08-.532A3.7 3.7 0 0 1 4.64 10.1q-.503-.933-.503-2.136c0-.802.167-1.538.503-2.152a3.7 3.7 0 0 1 1.405-1.448q.473-.276 1.025-.41V.862a7.1 7.1 0 0 0-2.631.879 6.97 6.97 0 0 0-2.597 2.567Q.896 5.928.895 7.966c0 1.358.315 2.552.947 3.642a6.9 6.9 0 0 0 2.597 2.58q1.647.947 3.684.948 1.606 0 2.996-.616a6.55 6.55 0 0 0 2.366-1.763l-2.064-2.094q-.602.719-1.448 1.075z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M12.281.865h-4.15v2.996h4.15v4.15h2.996V.866z"
  })));
};
export default SvgChargeShare;